var React = require('react');

function OneWay (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#009245"},[React.createElement("path",{"d":"M21.85 11.596l-1.626 1.626-6.434-6.434 1.626-1.627z","key":0}),React.createElement("path",{"d":"M21.807 11.581l-6.436 6.434-1.626-1.626 6.435-6.434z","key":1}),React.createElement("path",{"d":"M1.3 10.4h18.9v2.3H1.3z","key":2})]));
}

OneWay.defaultProps = {"viewBox":"0 0 23.2 23.2"};

module.exports = OneWay;

OneWay.default = OneWay;
